export const hasTransactionManualStop = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_TRANSACTION_MANUAL_STOP' &&
      !!permission.status,
  );
};
